import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../services/api";
import ToastContext from "../contexts/ToastContext";
import PageHeader from "../components/PageHeader";
import ConfirmationModal from "../components/ConfirmationModal";
import { FaRegFileAlt, FaEye, FaTrash } from "react-icons/fa";
import "./MeusRecursos.css";

function MeusRecursos() {
  const { addToast } = useContext(ToastContext);
  const [loading, setLoading] = useState(true);
  const [recursos, setRecursos] = useState([]);
  const [modalState, setModalState] = useState({ isOpen: false, recursoId: null });

  const canDelete = (r) => {
    const statusOk = r?.status === "Pendente" || r?.status === "Em Análise";
    const inicio = r?.data_inicio_recurso ? new Date(r.data_inicio_recurso) : null;
    const fim = r?.data_fim_recurso ? new Date(r.data_fim_recurso) : null;
    if (!inicio || !fim) return false;
    const agora = new Date();
    const withinWindow = agora >= inicio && agora <= fim;
    return statusOk && withinWindow;
  };

  useEffect(() => {
    let mounted = true;
    async function fetchRecursos() {
      setLoading(true);
      try {
        const { data } = await api.get("/recursos/minha");
        if (!mounted) return;
        setRecursos(Array.isArray(data) ? data : []);
      } catch (error) {
        addToast("Erro ao buscar seus recursos.", "error");
      } finally {
        if (mounted) setLoading(false);
      }
    }

    fetchRecursos();
    return () => {
      mounted = false;
    };
  }, [addToast]);

  const confirmDelete = async () => {
    const recursoId = modalState.recursoId;
    if (!recursoId) return;
    try {
      await api.delete(`/recursos/${recursoId}`);
      addToast("Recurso excluído com sucesso.", "success");
      setRecursos((prev) => prev.filter((r) => Number(r.id) !== Number(recursoId)));
    } catch (error) {
      addToast(error?.response?.data?.message || "Erro ao excluir recurso.", "error");
    } finally {
      setModalState({ isOpen: false, recursoId: null });
    }
  };

  return (
    <>
      <ConfirmationModal
        isOpen={modalState.isOpen}
        onClose={() => setModalState({ isOpen: false, recursoId: null })}
        onConfirm={confirmDelete}
        title="Excluir recurso"
        message="Tem certeza que deseja excluir este recurso? Esta ação não pode ser desfeita."
      />
      <PageHeader title="Meus Recursos" />
      <div className="recursos-list stack-lg">
        {loading ? (
          <p>Carregando...</p>
        ) : recursos.length ? (
          recursos.map((r) => (
            <div key={r.id} className="recurso-card surface-section">
              <div className="recurso-card__header">
                <h2>
                  <FaRegFileAlt style={{ marginRight: 8 }} />
                  {r.edital_titulo} - Edital Nº {r.numero_edital}/{r.ano_edital}
                </h2>
                <span className="pill">{r.status}</span>
              </div>
              <p>
                <strong>Inscrição:</strong> {String(r.inscricao_id).padStart(4, "0")}
              </p>
              <p>
                <strong>Cargo:</strong> {r.nome_cargo}
              </p>
              <p>
                <strong>Enviado em:</strong> {new Date(r.criado_em).toLocaleString()}
              </p>
              {r.atualizado_em ? (
                <p>
                  <strong>Atualizado em:</strong> {new Date(r.atualizado_em).toLocaleString()}
                </p>
              ) : null}

              <div className="recurso-card__actions">
                <Link className="btn-modern" to={`/recursos/${r.id}`}>
                  <FaEye />
                  <span>Ver detalhes</span>
                </Link>
                {canDelete(r) ? (
                  <button
                    type="button"
                    className="btn-modern btn-danger"
                    onClick={() => setModalState({ isOpen: true, recursoId: r.id })}
                    title="Excluir recurso"
                  >
                    <FaTrash />
                    <span>Excluir</span>
                  </button>
                ) : null}
              </div>
            </div>
          ))
        ) : (
          <p>Você ainda não enviou nenhum recurso.</p>
        )}
      </div>
    </>
  );
}

export default MeusRecursos;
